"use client"
import Text from "@/app/(site)/_components/Atoms/Text"
import { ShippingCountryCode } from "@/data/shipping-country-code"
import React, { useState, useEffect } from "react"

export interface Option {
    value: string
    label?: string
}

export interface CountryOptions extends Option {
    countryCode: ShippingCountryCode
}

export interface RadioButtonProps {
    options: Option[] | CountryOptions[]
    name?: string
    theme?: "light" | "dark"
    handleSelection?: (e: React.ChangeEvent<HTMLInputElement>, value: string) => void
    selectedValue?: string
}

const RadioButton: React.FC<RadioButtonProps> = ({
    options,
    name,
    theme = "dark",
    handleSelection,
    selectedValue
}) => {
    const [selected, setSelected] = useState<string | null>(selectedValue || null)

    useEffect(() => {
        if (!selectedValue) return

        setSelected(selectedValue)
    }, [selectedValue])

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, value: string) => {
        setSelected(value)

        if (handleSelection) {
            handleSelection(e, value)
        }
    }
    return (
        <div className="flex flex-col gap-16">
            {options &&
                options.map(option => (
                    <div className="flex cursor-pointer items-center" key={option.value}>
                        <div className="relative flex items-center">
                            <input
                                type="radio"
                                id={option.value}
                                name={name}
                                className={`h-24 w-24 cursor-pointer appearance-none rounded-full border-2 ${theme === "light" ? "border-black checked:bg-black" : "border-white checked:bg-white"}`}
                                checked={selected === option.value}
                                onChange={e => handleChange(e, option.value)}
                            />
                            {selected === option.value && (
                                <div
                                    className={`absolute inset-0 h-8 w-8 translate-x-8 translate-y-8 cursor-pointer ${theme === "light" ? "bg-main-white" : "bg-black"}`}
                                ></div>
                            )}
                        </div>
                        <label
                            htmlFor={option.value}
                            className="cursor-pointer select-none pl-8"
                        >
                            <Text
                                size="medium"
                                weight="regular"
                                className={`${theme === "light" ? "text-black" : "text-white"}`}
                            >
                                {option.label}
                            </Text>
                        </label>
                    </div>
                ))}
        </div>
    )
}

export default RadioButton
